import React, { useMemo } from 'react';
import Heading from '../../generic-components/Heading';
import { SUPPLIER_COLOR_MAP } from '../../pages/Supplier/consts';
import { getProfileColorId } from '../../pages/Supplier/helpers';

export enum AvatarSize {
  SMALL,
  MEDIUM,
  LARGE,
  XLRAGE,
}

interface AvatarProps {
  name: string;
  id: string;
  size: AvatarSize;
}

export const Avatar = ({ name, id, size }: AvatarProps) => {
  const initials = useMemo(() => {
    const splitWords = (name || '-').split(' ');
    return `${splitWords[0][0]}${splitWords?.[1]?.[0] || ''}`.toUpperCase();
  }, [name]);

  const circleSize = useMemo(() => {
    let sizePX = '34px';
    switch (size) {
      case AvatarSize.SMALL:
        sizePX = '20px';
        break;
      case AvatarSize.MEDIUM:
        sizePX = '28px';
        break;
      case AvatarSize.LARGE:
        sizePX = '34px';
        break;
      case AvatarSize.XLRAGE:
        sizePX = '40px';
        break;
      default:
        sizePX = '34px';
        break;
    }
    return `w-[${sizePX}] h-[${sizePX}] min-w-[${sizePX}] min-h-[${sizePX}]`;
  }, [size]);

  const fontSize = useMemo(() => {
    let sizePX = '16px';
    switch (size) {
      case AvatarSize.SMALL:
        sizePX = '9px';
        break;
      case AvatarSize.MEDIUM:
        sizePX = '13px';
        break;
      case AvatarSize.LARGE:
        sizePX = '16px';
        break;
      case AvatarSize.XLRAGE:
        sizePX = '18px';
        break;
      default:
        return 'text-[16px]';
    }
    return `text-[${sizePX}]`;
  }, [size]);
  return (
    <div
      style={{ backgroundColor: SUPPLIER_COLOR_MAP[getProfileColorId(id || '') as keyof typeof SUPPLIER_COLOR_MAP] }}
      className={`relative flex overflow-hidden rounded-[50%] ${circleSize}`}
    >
      <Heading
        title={initials}
        className={`${fontSize}  absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 leading-none font-metricRMedium text-bw00 `}
      />
    </div>
  );
};
